class EditSimulationDataInstancesModalController {
    constructor(UserServiceApi) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.data = {
                tester: null,
                simId: -1
            };
            let testerId = this.resolve.testerId;
            let simId = this.resolve.simId;
            this.UserServiceApi.getUser(testerId).then((response) => {
                let tester = response.data;
                this.data = {
                    tester: { Id: tester.Id, Name: tester.UserName },
                    simId: simId
                };
            });
        };
        this.cancel = () => {
            this.dismiss();
        };
        this.UserServiceApi = UserServiceApi;
    }
}
angular.module('app').component('editSimulationDataInstancesModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/SimulationData/user/edit-simulation-data-instances-modal.tpl.html',
    controllerAs: 'vm',
    controller: EditSimulationDataInstancesModalController
});
